class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
    if (this.header) this.header.preventHide = false;

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.header) this.header.preventHide = true;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden-drawer');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden-drawer');
    if (this.header) this.header.preventHide = false;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
     
 if (section.id == 'cart-icon-bubble') {
 
   // console.log( this.getSectionInnerHTML(parsedState.sections[section.id], section.selector));
          let sectionHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

            // Replace the word "Winkelwagen" anywhere in the HTML with the SVG icon
            sectionHTML = sectionHTML.replace(/Winkelwagen/g, `
            <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5301 3.99999H6.11336L4.53979 1.17945C4.36317 0.862861 4.02903 0.666656 3.6665 0.666656H1.6665C1.11422 0.666656 0.666504 1.11437 0.666504 1.66666C0.666504 2.21894 1.11422 2.66666 1.6665 2.66666H3.0793L4.63223 5.45019L8.21366 13.3745L8.21733 13.3826L8.53278 14.0805L4.93699 17.9161C4.67844 18.1918 4.59751 18.5898 4.72782 18.9447C4.85813 19.2996 5.1774 19.5506 5.55298 19.5935L8.83049 19.9681C12.9301 20.4366 17.0697 20.4366 21.1692 19.9681L24.4467 19.5935C24.9955 19.5308 25.3894 19.0352 25.3267 18.4864C25.264 17.9377 24.7684 17.5438 24.2196 17.6065L20.9421 17.981C16.9935 18.4323 13.0063 18.4323 9.05759 17.981L7.7569 17.8324L10.3961 15.0173C10.4216 14.99 10.4453 14.9618 10.4672 14.9326L11.471 15.0632C12.8775 15.2462 14.2993 15.2821 15.7133 15.1702C19.0113 14.9094 22.0679 13.3401 24.2018 10.8121L24.9726 9.89899C24.9984 9.86833 25.0225 9.83613 25.0445 9.80258L26.481 7.61344C27.4992 6.06176 26.3861 3.99999 24.5301 3.99999ZM10.5415 12.9254C10.321 12.8967 10.1308 12.7566 10.038 12.5547L10.0362 12.5508L7.07549 5.99999H24.5301C24.7953 5.99999 24.9543 6.29453 24.8088 6.5162L23.4054 8.65496L22.6735 9.52202C20.8841 11.6418 18.3211 12.9578 15.5556 13.1765C14.2802 13.2773 12.9977 13.245 11.729 13.0799L10.5415 12.9254Z" fill="black"></path> <path d="M7.66651 21.6667C6.56194 21.6667 5.66651 22.5621 5.66651 23.6667C5.66651 24.7712 6.56194 25.6667 7.66651 25.6667C8.77108 25.6667 9.66651 24.7712 9.66651 23.6667C9.66651 22.5621 8.77108 21.6667 7.66651 21.6667Z" fill="black"></path> <path d="M20.3332 23.6667C20.3332 22.5621 21.2286 21.6667 22.3332 21.6667C23.4377 21.6667 24.3332 22.5621 24.3332 23.6667C24.3332 24.7712 23.4377 25.6667 22.3332 25.6667C21.2286 25.6667 20.3332 24.7712 20.3332 23.6667Z" fill="black"></path> </svg>
            `);

            sectionElement.innerHTML = sectionHTML;
 }
      else{
         sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        
      }
     
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
   
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
